import { Button, Group, Select } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {
  clearAuditTrail,
  setChartType,
  useSelectAuditTrailChartType,
  useSelectAuditTrailGroupByValue,
  useSelectAuditTrailSelectValue,
} from "../../../redux/features/auditTrail/auditTrailSlice";
import { useGenerateChartMutation } from "./useAuditTrailQueries";

const AuditTrailActions = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectValue = useSelectAuditTrailSelectValue();
  const groupByValue = useSelectAuditTrailGroupByValue();
  const chartType = useSelectAuditTrailChartType();
  const { mutate: generateChart, isPending } = useGenerateChartMutation();

  const generateDisabled =
    !selectValue.length || !groupByValue.length || isPending;

  const handleGenerate = () => {
    const postData = {
      groupByTypes: groupByValue.map((e) => e.type),
      selectTypes: selectValue.map((e) => e.type),
    };
    [...selectValue, ...groupByValue].forEach((e) => {
      postData[e.postValueType] = e.value;
    });
    generateChart(postData);
  };

  const chartTypeItems = [
    { value: "count", label: t("auditTrail.showCount") },
    { value: "percentage", label: t("auditTrail.showPercent") },
  ];

  return (
    <Group justify="space-between" align="flex-end">
      <Button
        variant="outline"
        color="black"
        disabled={!selectValue.length && !groupByValue.length}
        onClick={() => dispatch(clearAuditTrail())}
      >
        Clear
      </Button>
      <Group align="flex-end">
        <Select
          data={chartTypeItems}
          value={chartType}
          onChange={(val) => val && dispatch(setChartType(val))}
          allowDeselect={false}
          w={200}
        />
        <Button
          disabled={generateDisabled}
          loading={isPending}
          onClick={handleGenerate}
        >
          Generate chart
        </Button>
      </Group>
    </Group>
  );
};

export default AuditTrailActions;
